(function () {
    class TemplateSetup {
        constructor(
            $scope,
            $state,
            notify,
            LandingPagesService,
            ErrorService,
            ImageResourceService,
            PermissionService,
            $uibModal
        ) {
            this._scope = $scope;
            this._state = $state;
            this._uibModal = $uibModal;
            this.moment = moment;
            this.notify = notify;
            this.errorService = ErrorService;
            this.landingPagesService = LandingPagesService;
            this.imageResourceService = ImageResourceService;
            this.permissionService = PermissionService;
            this.templateOptions = [];
            this.selectedTemplateOption = undefined;

            this.editorConfig = {
                language: 'en',
                allowedContent: true,
                fullPage: true,
                extraPlugins: 'sourcedialog',
                removePlugins: 'sourcearea',
                versionCheck: false
            };

            this.pageId = $state.params.pageId;
            this.brandId = $state.params.brandId;
            this.editing = !!this.pageId;

            this.checkPermissions();

            window.CKEDITOR.on('instanceReady', (ev) => this.editor = ev.editor);

            this.landingPagesService.fetchLandingPageTemplates(this.brandId)
                .then((data) => {
                    this.setupTemplatesAndFetchPage(data);
                })
                .catch((error) => {
                    this.errorService.showError("There was an issue loading the page", error);
                });
        }

        watchForTemplateChange() {
            this._scope.$watch("$ctrl.selectedTemplateOption", (newValue, oldValue) => {
                if (!newValue?.Content) {
                    return;
                }
                if (newValue.Name === oldValue?.Name) {
                    return;
                }
                this.content = newValue.Content;
            });
        }

        setupTemplatesAndFetchPage(data) {
            this.templateOptions = data;
            this.selectedTemplateOption = data.length
                ? data[0]
                : undefined;
            this.fetch();
        }

        checkPermissions() {
            const canEditPage = this.permissionService.doesUserHaveAnyPermission([ Dashboard.Models.Lookups.Permissions.EditLandingPage ]);
            this.disableNextButton = !canEditPage;
        }

        insertFeaturedImage() {
            if (!this.resourceUrl) {
                return;
            }
            this.insertHTML(`<img src="${ this.resourceUrl }" alt="featured image" />`);
        }

        insertHTML(value) {
            if (!this.editor) {
                throw new Error("The editor is not ready");
            }
            this.editor.insertHtml(value, 'text');
        }

        generateResourceUrl() {
            if (!this.resourceId) {
                return;
            }
            this.resourceUrl = this.imageResourceService.getUrlForResource(this.resourceId);
        }

        $postLink() {
            const el = document.querySelector('#getFile');
            el
                ? el.onchange = (event) => this.uploadImageResource(event.target.files)
                : undefined;
        }

        static MaxFileSize = 150 // kb
        uploadImageResource(files) {
            this.uploadInProgress = true;
            for (const file of files) {
                const fileSizeInKb = file.size / 1024;
                if (fileSizeInKb > TemplateSetup.MaxFileSize) {
                    this.featuredImageUploadError = `The file ${ file.name } exceeds the maximum file size - ${ TemplateSetup.MaxFileSize }KB`;
                    this.uploadInProgress = false;
                    return this._scope.$apply();
                }
            }
            this.featuredImageUploadError = false;
            this.landingPagesService.uploadFeaturedImage(this.landingPage.Id, files)
                .then(response => {
                    this.uploadInProgress = false;
                    this.resourceId = response;
                    this.generateResourceUrl();
                })
                .catch(() => {
                    this.uploadInProgress = false;
                    this.featuredImageUploadError = "Unable to upload the featured image";
                });
        }

        removeFeaturedImage() {
            this.landingPagesService.removeFeaturedImage(this.pageId)
                .finally(() => {
                    this.fetch();
                });
        }

        fetch() {
            this.landingPagesService.fetchLandingPageById(this.pageId)
                .then((data) => {
                    this.landingPage = data;
                    this.content = this.fetchContent(data);
                    this.resourceId = data.ResourceId;
                    const previewUrl = this._state.href("app.landingpages.edit", {
                        preview: data.CardGuid
                    })
                    this.previewUrl = `${ location.origin }/dashboard/${ previewUrl }`
                    this.generateResourceUrl();
                    this.watchForTemplateChange();
                })
                .catch((error) => {
                    this.errorService.showError("There was an issue loading the page", error);
                });
        }

        fetchContent(data) {
            return data.Content
                ? data.Content
                : this.selectedTemplateOption
                    ? this.selectedTemplateOption.Content
                    : "";
        }

        resolveClassNameFromBrand() {
            const rawBrandName = this.permissionService.userContext.BrandName;
            if (!rawBrandName) {
                return "";
            }
            const splitBrandName = rawBrandName.split(' ')[0];
            return splitBrandName.toLowerCase();
        }

        openPreview() {
            const brandClass = this.resolveClassNameFromBrand();
            const templateUrl = "components/landingpages/wizard/step-2/preview/preview-modal.92a9bc29.html";
            this._uibModal.open({
                animation: true,
                templateUrl,
                controller: "wizardPreviewModal",
                backdrop: 'static',
                resolve: {
                    content: () => this.content,
                    brandClass: () => brandClass
                }
            })
        }

        nextStep() {
            try {
                this.validateInput();
            } catch (error) {
                return this.errorService.showError(error.message);
            }
            this.updateLandingPageContent();
        }

        validateInput() {
            if (!this.content) {
                throw Error("Landing page content is required");
            }
        }

        previousStep() {
            this._state.go("app.landingpages.details", this._state.params);
        }

        updateLandingPageContent() {
            this.landingPagesService.updateLandingPageContent(this.pageId, {
                content: this.content,
                resourceId: this.resourceId
            }).then(() => {
                this.notify.success('Updated successfully');
                this._state.go("app.landingpages.placement", this._state.params);
            }).catch((error) => {
                this.errorService.showError(
                    "Oops! there was an issue updating this landing page. Please try again",
                    error);
            });
        }
    }

    angular
        .module('dashboard')
        .component('templateSetup', {
            templateUrl: 'components/landingpages/wizard/step-2/template-setup.8bf7c26a.html',
            controller: [
                '$scope',
                '$state',
                'notify',
                'LandingPagesService',
                'ErrorService',
                'ImageResourceService',
                'PermissionService',
                '$uibModal',
                TemplateSetup ]
        });
})();
